import LoadingIndicator from "src/components/LoadingIndicator";
import { getCampaign_campaign_contactImportJob } from "src/graphql/generated/getCampaign";

export default function JobRunning({
  job
}: {
  job: getCampaign_campaign_contactImportJob;
}): JSX.Element {
  return (
    <LoadingIndicator
      progress={job.progress}
      message={
        <>
          <span>Importing ({(job.progress * 100).toFixed(1)}%)...</span>
          <br />
          <em>You can leave and the import will continue in the background</em>
        </>
      }
    />
  );
}
